import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../brand/BrandLogo';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import ThemeToggle from '../ui/ThemeToggle';

const MarketingNavbar = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-40 border-b border-gold-500/20 bg-zinc-50/85 backdrop-blur-md dark:border-aura-800/80 dark:bg-[#07040f]/90">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <BrandLogo to="/" size="md" showWordmark onClick={closeMenu} />

        <div className="hidden items-center gap-3 md:flex">
          <LanguageSwitcher />
          <ThemeToggle />
          <Link
            to="/explore"
            className="rounded-lg px-4 py-2 text-sm text-zinc-700 transition hover:text-glow-500 dark:text-zinc-300 dark:hover:text-glow-300"
          >
            {t('common.explore')}
          </Link>
          <Link
            to="/marketplace"
            className="rounded-lg px-4 py-2 text-sm text-zinc-700 transition hover:text-glow-500 dark:text-zinc-300 dark:hover:text-glow-300"
          >
            {t('common.marketplace')}
          </Link>
          <Link
            to="/login"
            className="rounded-lg px-4 py-2 text-sm text-zinc-700 transition hover:text-glow-500 dark:text-zinc-300 dark:hover:text-glow-300"
          >
            {t('marketing.login')}
          </Link>
          <Link
            to="/request-tenant"
            className="rounded-lg bg-gradient-to-r from-aura-600 to-glow-600 px-4 py-2 text-sm font-medium text-white transition hover:from-aura-500 hover:to-glow-500"
          >
            {t('marketing.partnerWithUs')}
          </Link>
        </div>

        <button
          type="button"
          className="rounded-lg p-2 text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-aura-900 md:hidden"
          aria-label={menuOpen ? t('common.closeMenu') : t('common.openMenu')}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {menuOpen && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-40 bg-black/50 md:hidden"
            aria-label={t('common.closeMenu')}
            onClick={closeMenu}
          />
          <div className="absolute inset-x-0 top-full z-50 border-b border-gold-500/20 bg-zinc-50 p-4 shadow-lg dark:border-aura-800 dark:bg-[#0e0818] md:hidden">
            <nav className="flex flex-col gap-2">
              <LanguageSwitcher className="w-full" selectClassName="w-full" />
              <ThemeToggle className="w-full justify-center" />
              <Link
                to="/explore"
                onClick={closeMenu}
                className="rounded-lg px-3 py-2.5 text-sm text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-aura-900"
              >
                {t('common.explore')}
              </Link>
              <Link
                to="/marketplace"
                onClick={closeMenu}
                className="rounded-lg px-3 py-2.5 text-sm text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-aura-900"
              >
                {t('common.marketplace')}
              </Link>
              <Link
                to="/login"
                onClick={closeMenu}
                className="rounded-lg px-3 py-2.5 text-sm text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-aura-900"
              >
                {t('marketing.login')}
              </Link>
              <Link
                to="/request-tenant"
                onClick={closeMenu}
                className="rounded-lg bg-gradient-to-r from-aura-600 to-glow-600 px-3 py-2.5 text-center text-sm font-medium text-white"
              >
                {t('marketing.partnerWithUs')}
              </Link>
            </nav>
          </div>
        </>
      )}
    </header>
  );
};

export default MarketingNavbar;
